import { apiRequest } from "../util/apiUtils";

export const categoryList = async (params) => {
  try {
    const res = await apiRequest("get", `category/list`, {
      queries: params,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const categoryAddEdit = async (payload) => {
  try {
    const res = await apiRequest(
      payload?.id ? "put" : "post",
      `category/${payload?.id ? "edit" : "add"}`,
      {
        body: payload,
      },
      "multipart/form-data"
    );

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const categoryDelete = async (payload) => {
  try {
    const res = await apiRequest("delete", `category/delete-all`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const categoryStatusChange = async (payload) => {
  try {
    const res = await apiRequest("patch", `category/status`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};
